import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-screen h-screen z-50 flex justify-center items-center bottom-0 left-0 fixed bg-gray-400 bg-opacity-80 overflow-auto"
}
const _hoisted_2 = { class: "w-10/12 lg:w-75 md:w-10/12 max-w-lg h-10/12 bg-white rounded-md md:p-10 flex flex-col grid grid-cols-1 mt-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "cursor-pointer font-bold hover:text-sirit_blue-400" }, "x", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-medium mt-2 mb-10 text-center" }, " Elije los servicios que quieres contratar con nocotros ", -1)
const _hoisted_6 = { class: "w-full grid grid-cols-1 sm:grid-cols-2 gap-3 text-left" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold pt-3" }, "Servicio Gestión Amistosa", -1)
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold pt-3 ml-1" }, "Servicio de Recuperación Legal", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.step)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "text-right",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal()))
            }, _hoisted_4),
            _hoisted_5
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  id: "input-company",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.setDate())),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data_.day) = $event)),
                  type: "check",
                  class: "boder w-full h-5 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3",
                  required: ""
                }, null, 544), [
                  [_vModelText, $setup.data_.day]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  id: "input-cif",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.setDate())),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data_.month) = $event)),
                  type: "number",
                  min: "1",
                  max: "12",
                  autocomplete: "off",
                  placeholder: "mm",
                  class: "boder w-full h-5 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 p-3",
                  required: ""
                }, null, 544), [
                  [_vModelText, $setup.data_.month]
                ])
              ])
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}